// removed by extract-text-webpack-plugin
module.exports = {"rightMargin":"styles__rightMargin__3hZpU","noTopPadding":"styles__noTopPadding__MvvAZ","noTopMargin":"styles__noTopMargin__3hYWf","verticalCenterChildren":"styles__verticalCenterChildren__3HXyg","rightAlignText":"styles__rightAlignText__3T3fS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/styles.scss
// module id = 359
// module chunks = 0